import React from "react";

import { IoMdClose, IoMdCheckmark } from "react-icons/io";
const BillingFeature = ({ hasFeature, detail }) => {
  return (
    <div className="feature-details">
      <div className="feature-icon">
        {hasFeature ? (
          <IoMdCheckmark className="has-feature" />
        ) : (
          <IoMdClose className="has-not-feature" />
        )}
      </div>
      <div className="feature-detail">{detail}</div>
    </div>
  );
};

export default BillingFeature;
